<p-accordion [value]="selectedValue ? internalId : null" (valueChange)="onAccordionValueChange($event)">

  <p-accordion-panel [value]="internalId"
                     [ngClass]="{'bulb-focus': tabHasFocus}"
                     [disabled]="disabled">

    <p-accordion-header>
      <ng-content select="[header]"></ng-content>
    </p-accordion-header>

    <p-accordion-content>
      <ng-content select="[content]"></ng-content>
    </p-accordion-content>

  </p-accordion-panel>

</p-accordion>
